import { NSARouterMakerResult } from "namirasoft-account-react";
import { EntityType } from "namirasoft-expert";
import { NSMenuActionProps } from "namirasoft-site-react";
import { ExpertRoutes } from "./ExpertRoutes";

export class ExpertMenus
{
    static chat(getIDs: () => string[], props: NSARouterMakerResult): NSMenuActionProps[]
    {
        let agent_id = getIDs()[0];
        let isActive = () => getIDs().length === 1;

        return [{
            id: "1",
            menu_item: "New Chat",
            isActive,
            onClick: {
                action: () => props.url.redirect(ExpertRoutes.Chat_AgentNew(agent_id), {})
            }
        }];
    }
    static test(getIDs: () => string[], props: NSARouterMakerResult): NSMenuActionProps[]
    {
        let agent_id = getIDs()[0];
        let isActive = () => getIDs().length === 1;

        const items: { id: string; label: string; entity_type: EntityType }[] = [
            { id: "1", label: "Cloud", entity_type: EntityType.Cloud },
            { id: "2", label: "Server", entity_type: EntityType.Server },
            { id: "3", label: "Kubernetes", entity_type: EntityType.Kubernetes },
            { id: "4", label: "Container", entity_type: EntityType.Container },
            { id: "5", label: "Database", entity_type: EntityType.Database },
            { id: "6", label: "Cache", entity_type: EntityType.Cache },
            { id: "7", label: "Messaging", entity_type: EntityType.Messaging },
            { id: "8", label: "Streaming", entity_type: EntityType.Streaming },
            { id: "9", label: "Metric", entity_type: EntityType.Metric },
        ];

        return items.map(({ id, label, entity_type }) => ({
            id,
            menu_item: label,
            isActive,
            onClick: {
                action: () => props.url.redirect(ExpertRoutes.AgentTest(agent_id, entity_type), {})
            }
        }));
    }
}